// https://hypergryph.feishu.cn/wiki/BlB3wOjOLiXX2Hko16KcVIQEnsc
var Media = /** @class */ (function () {
    function Media(props) {
        Object.defineProperty(this, "adapter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.adapter = props.adapter;
    }
    Object.defineProperty(Media.prototype, "audio", {
        /**
         * media_audio 参数
         */
        get: function () {
            var media_audio = this.adapter.getStore().media_audio;
            return media_audio;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Media.prototype, "video", {
        /**
         * media_video 参数
         */
        get: function () {
            var media_video = this.adapter.getStore().media_video;
            return media_video;
        },
        enumerable: false,
        configurable: true
    });
    return Media;
}());
export { Media };
